'use client';

import { useMemo } from 'react';
import { useGardenPlannerStore } from '@shared/store/useGardenPlannerStore';
import { getPlantCounts } from '@modules/garden-planner/business_logic';
import { PlantSelectorContainer } from '@modules/garden-planner/containers/plant_selector_container';
import {
  useGarden,
  useGardenPlannerContext,
} from '@modules/garden-planner/context/garden_planner_context';
import type { GardenPlannerViews } from '@modules/garden-planner/garden_planner_views';

interface PlantSelectionToolContainerProps {
  views: GardenPlannerViews;
}

export function PlantSelectionToolContainer({ views }: PlantSelectionToolContainerProps) {
  const { plants } = useGardenPlannerContext();
  const garden = useGarden();
  const { PlantSelectionToolView } = views;
  const isPlantSelectionMode = useGardenPlannerStore((state) => state.isPlantSelectionMode);
  const selectedPlant = useGardenPlannerStore((state) => state.selectedPlant);
  const setSelectedPlant = useGardenPlannerStore((state) => state.setSelectedPlant);
  const setActiveMode = useGardenPlannerStore((state) => state.setActiveMode);

  const plantCounts = useMemo(
    () => getPlantCounts(plants, garden.plants),
    [plants, garden.plants]
  );
  const handleToggle = () => setActiveMode(isPlantSelectionMode ? null : 'plant');

  return (
    <PlantSelectionToolView
      isActive={isPlantSelectionMode}
      onToggle={handleToggle}
      plantSelector={
        isPlantSelectionMode ? (
          <PlantSelectorContainer
            views={views}
            selectedPlant={selectedPlant}
            onPlantSelect={setSelectedPlant}
            plantCounts={plantCounts}
            autoOpen={true}
          />
        ) : null
      }
    />
  );
}
